import Hero from "@/components/Hero";
import Services from "@/components/Services";
import About from "@/components/About";
import WhyChooseUs from "@/components/WhyChooseUs";
import SuccessStories from "@/components/SuccessStories";
import Sustainability from "@/components/Sustainability";
import Contact from "@/components/Contact";

const Home = () => {
  return (
    <main className="overflow-hidden">
      <Hero
        badge="Soluciones en Eficiencia Energética"
        title="Revolucionamos la gestión energética"
        subtitle="Integramos tecnología para un consumo más inteligente"
      />

      <About />
      <Services />
      <WhyChooseUs />
      <SuccessStories />
      <Sustainability />
      <Contact />
    </main>
  );
};

export default Home;
